import _ from 'underscore';

export const formatLocationCriterion = (criterions) => {
  const rawLocations = _.filter(criterions, criterion => criterion.Criterion.Type === 'Radius' || criterion.Criterion.Type === 'Location');
  const locations = _.map(rawLocations, (location) => {
    const type = location.Criterion && location.Criterion.Type;
    const isNegative = location['@odata.type'] === '#Model.NegativeCampaignCriterion';

    return {
      Id: location.Id,
      SelectionStatus: isNegative ? 'Excluded' : 'Included',
      CriterionType: isNegative ? 'NegativeLocation' : type,
      Criterion: {
        Type: type,
        [type === 'Radius' ? 'RadiusCriterion' : 'LocationCriterion']: location.Criterion,
      },
    };
  });

  return locations;
};

